// extracted by mini-css-extract-plugin
export default {"button":"Button_button__aw-fo","label":"Button_label__mlyFS","accent":"Button_accent__ua-w9","success":"Button_success__hhtxM","grey":"Button_grey__dikIf"};